<script>
export default {};
</script>

<template>
  <span class="Card-table-link-indicator-outer">
    <span class="Card-table-link-indicator">
      <font-awesome-icon icon="chevron-right" size="xs" />
    </span>
  </span>
</template>

<style scoped>
.Card-table-link-indicator-outer {
  width: 10px;
  display: inline-block;
}

.Card-table-link-indicator {
  color: #007bff;
  display: inline-flex;
  align-items: center;

  opacity: 0;

  transition: all 200ms;
}

tr:hover .Card-table-link-indicator {
  opacity: 1;

  margin-left: 0.35rem;
}
</style>
